import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FilesSection.html?raw';
import FileUpload from '../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import Button from '../../../moreCore/UI/Button/Button';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { AddressWizardTypes } from "../AddressWizardTypes";
class AddressFilesSection extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private fileUpload: MdsLax<InstanceType<typeof FileUpload>>;

    private tableContainer: HTMLTableElement;
    private filesTable: MdsLax<InstanceType<typeof StaticTable>>;

    private uploadData: any;
    private deletedData: Array<string> = [];
    private sectionData: any;
    private _undirtyData: string;
    dirty: boolean = false;

    private _initialData: Array<AddressWizardTypes.HtFile> = null;

    setData(inputData: Array<AddressWizardTypes.HtFile>) {
        this._initialData = inputData;

        this.drawTable(inputData);
    }

    getData() {
        return this.sectionData;
    }

    private _onUploadFile(p1, p2, p3) {
        this.serializeData();
    }

    private serializeData(resetDirty?: boolean) {
        let values = this.fileUpload.getValue();
        this.uploadData = values;

        this.sectionData = {
            uploaded: values,
            deleted: this.deletedData
        };

        this.checkDirty(resetDirty === true);
    }

    private checkDirty(bReset?: boolean) {
        let txtValue = JSON.stringify(this.sectionData);
        let dirty = false;
        if (bReset === true) {
            this._undirtyData = txtValue;
        }

        if (txtValue != this._undirtyData) {
            dirty = true;
        }

        if (this.dirty != dirty) {
            this.dirty = dirty;

            this.emit("dirty", this.dirty);
        }
    }

    private _downloadFile(data: AddressWizardTypes.HtFile) {
        window.open(window.appRoot + `AddressWizard/DownloadExistingFile?downloadKey=${data.ref_vt_file.ID}`);
    }

    private _deleteFile(cell: StaticTable.StaticTableCell<AddressWizardTypes.HtFile>) {
        let tr = cell.tableRow.node;
        this.filesTable.removeRow(cell.tableRow.rowGroup.rowIndex);

        this.deletedData.push(cell.entity.ID);
        this.serializeData();
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<AddressWizardTypes.HtFile>): boolean {
        switch (cell.name) {
            case "actions":
                let btnDownload = new Button();
                btnDownload._onClick_Button = lang.hitch(this, this._downloadFile, cell.entity);
                btnDownload.setLabel("");
                btnDownload.setIconLeft("fas fa-download");
                btnDownload.setClasses("hoverDark downloadBtn");
                this.UiModder.domStyle.set(btnDownload.domNode, "float", "left");

                btnDownload.placeAt(cell.tableCellNode);

                let btnRemove = new Button();
                btnRemove._onClick_Button = lang.hitch(this, this._deleteFile, cell);
                btnRemove.setLabel("");
                btnRemove.setIconLeft("fas fa-trash warningTXT");
                btnRemove.setClasses("hoverDark deleteBtn");
                this.UiModder.domStyle.set(btnRemove.domNode, "float", "left");

                btnRemove.placeAt(cell.tableCellNode);

                return true;
                break;
        }

        return false;
    }

    private drawTable(data: Array<AddressWizardTypes.HtFile>): void {
        let table = new StaticTable();
        this.filesTable = table;
        table.setFormatter(lang.hitch(this, this._tableFormatter));
        table.setLayout({
            name: "-",
            label: "-",
            rows: [{
                attributes: ["ref_vt_file.filename", "ref_vt_file.ID"],
                headings: ["Filename", ""],
                colNamesInternal: ["filename", "actions"],
                colspans: [1]
            }]
        });

        table.placeAt(this.tableContainer, "only");
        table.setData(data);
        table.setCyAttribute("filesSection");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.deletedData = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(AddressFilesSection);
